export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4040'

// Supported tokens for invoice payments
export type SupportedToken = 'USDC' | 'EURC'

export const USDC_DECIMALS = 6
export const USDC_MINT = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'

export const EURC_DECIMALS = 6
export const EURC_MINT = 'HzwqbKZw8HxMN6bF2yFZNrht3c2iXXzpKcFu7uBEDKtr'

// Map currency to token
export const CURRENCY_TOKEN_MAP: Record<string, SupportedToken> = {
  usdc: 'USDC',
  usd: 'USDC',
  eur: 'EURC',
}

// Get token symbol for display
export function getTokenSymbol(currency: string): string {
  const lowerCurrency = currency?.toLowerCase()
  if (lowerCurrency === 'eur') return 'EURC'
  return 'USDC'
}
